import React from 'react'
import { useState, useEffect } from 'react'
import { useAuth } from '../../AuthContext'

function InstagramConnect() {


    const myContext = useAuth()

    const handleInstagramConnect = () => {
        const clientId = "1738890550846301";
        const redirectUri = encodeURIComponent("https://api.schedpilot.com/wp-json/api/v1/instagram-callback");
        const scope = encodeURIComponent("openid profile email w_member_social");
        const state = "some_data_here";  // Should be generated per request
        const jwt_token = "123" ;
    
     
        //const linkedInUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&jwt_token=${jwt_token}&state=${state}`;
        const instagramUrl = `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=instagram_business_basic%2Cinstagram_business_content_publish%2Cinstagram_business_manage_insights`;

        const width = 600, height = 600;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;
    
        const authWindow = window.open(
            instagramUrl,
            'LinkedInAuth',
            `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`
        );
    
    
    
        window.addEventListener("message", event => {
            if (event.data.type === "instagram-authenticated") {

                console.log(event.data);
                
                const mytoken = event.data.token;
    
    
 
     fetch('https://api.schedpilot.com/wp-json/api/v2/register-instagram-token', {
                method: 'POST',
                credentials: 'include', 
                headers: {
                    'Content-Type': 'application/json', 
                },
                body: JSON.stringify({ instagramToken: mytoken })
            }) .then(data => data.json()).then(MYJSON =>{
                
                
                myContext.getAccountsData();
                
            });  
    
    
                
                authWindow.close();
                // Optionally, you can update the UI to reflect the user's authenticated status
            }
        });
    
    
        // Optional: Monitor the popup window
        const interval = setInterval(() => {
            if (authWindow.closed) {
                clearInterval(interval);
                // Handle the case where the user closes the popup without completing the flow
                console.log("User closed the window");
            }
        }, 1000);
    };



    const InstagramConnectButton = () =>
        {
       
  
          return(
              <>
              <button className='btn btn-primary' onClick={handleInstagramConnect}>Connect Instagram</button>
              </>
          )
        }

        

        return <InstagramConnectButton />;  

}

export {  InstagramConnect };